import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { useAlert } from '../../hooks/use-alert.js';
var Callout = function Callout(_ref) {
  var _ref$objectId = _ref.objectId,
    objectId = _ref$objectId === void 0 ? '' : _ref$objectId,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'success' : _ref$variant,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? false : _ref$isClosable,
    title = _ref.title,
    description = _ref.description,
    showIcon = _ref.showIcon,
    onClose = _ref.onClose;
  /**
   * Hooks
   */
  var showAlert = useAlert(variant, 'inline');
  /**
   * DOM
   */
  var objectType = useMemo(function () {
    if (!objectId) {
      return "core-callout";
    }
    return "core-callout-".concat(objectId);
  }, [objectId]);
  return /*#__PURE__*/React.createElement(Box, {
    "data-object-type": objectType,
    className: "core-callout",
    "data-attribute": variant,
    role: variant === 'error' ? 'alert' : undefined
  }, showAlert({
    id: "".concat(variant, "-callout"),
    title: title,
    description: description,
    isClosable: isClosable,
    showIcon: showIcon,
    onClose: onClose
  }));
};
Callout.displayName = "Callout";
export { Callout };